class Dom {
  constructor (el) {
    this.el = el
  }

  dropdown (ref) {
    if (this.el) {
      var closeDropdown = (e) => {
        if (this.el.$refs[ref]) this.el.$refs[ref].style.display = 'none'
        window.removeEventListener('mouseup', closeDropdown, false)
      }
      this.el.$refs[ref].style.display = 'block'
      window.addEventListener('mouseup', closeDropdown, false)
    }
  }

  hasClass (args) {
    let currentClass = this.el.className.replace('  ', ' ').split(' ').filter(String)
    return currentClass.includes(args)
  }

  addClass (args) {
    let currentClass = this.el.className.replace('  ', ' ').split(' ').filter(String)
    let classToAdd = args.replace('  ', ' ').split(' ').filter(String)
    this.el.className = [...currentClass, ...classToAdd].join(' ')
    return this
  }

  removeClass (args) {
    let currentClass = this.el.className.replace('  ', ' ').split(' ').filter(String)
    let classToRemove = args.replace('  ', ' ').split(' ').filter(String)
    let classes = currentClass.filter(function (el) {
      return !classToRemove.includes(el)
    })
    this.el.className = classes.join(' ')
    return this
  }

  serializeForm () {
    let last = {}
    let re = /(\w+)/gi
    for (let field of this.el.elements) {
      if (field.name && !field.disabled && field.type !== 'file' &&
      field.type !== 'reset' && field.type !== 'submit' &&
      field.type !== 'button' && field.type !== 'display') {
        let names = field.name.match(re)
        let name = names[0]
        for (let i in names) {
          i = parseInt(i)
          name = names[i]
          // Currently does not fix multiple same names, but does for checkboxes
          if (i === names.length - 1 && !field.type === 'checkboxes') {
            last[name] = ''
          } else if (!last.hasOwnProperty(name)) {
            if (names.length !== 1) {
              last[name] = {}
            } else {
              last[name] = ''
            }
          }
          if (i < names.length - 1) {
            last = last[name]
          }
        }
        if (field.type === 'checkboxes') {
          for (let value of field.value) {
            if (!Array.isArray(last[name])) {
              last[name] = []
            }
            last[name].push(value)
          }
        } else {
          last[name] = field.value
        }
      }
    }
    return last
  }
}
export default function (el) {
  return new Dom(el)
}



// WEBPACK FOOTER //
// ./src/util/dom.js